import {classList, listen, lazyCustomElements} from 'nuffjs';

const conf = {
	headerName: 'app-header-with-search-with-colors',
	toggledClass: 'toggled',
};

class HighContrastToggler extends HTMLButtonElement {
	static conf = conf;

	toggled = false;

	async firstConnectedCallback() {
		this.header = await lazyCustomElements.querySelector(
			document.body,
			`[is="${conf.headerName}"]`
		);
		this.currentColorIndex = this.header.getCurrentColorIndex();
		const colors = this.header.getAccentColors();
		for (let i = 0; i < colors.length; i++) {
			if (colors[i].highContrast) {
				this.highContrastColorIndex = i;
				break;
			}
		}
		listen(this, 'click', this.onClick.bind(this));
	}

	async onClick(event) {
		this.blur();
		if (!this.toggled) {
			this.currentColorIndex = this.header.getCurrentColorIndex();
		}
		if (this.highContrastColorIndex !== this.currentColorIndex) {
			this.toggled = !this.toggled;
			classList(this).toggle(conf.toggledClass, this.toggled);
			const nextIndex = this.toggled ? this.highContrastColorIndex : this.currentColorIndex;
			this.header.setColorByIndex(nextIndex);
		}
	}
}

export {HighContrastToggler};
